import { useRecoilValue } from "recoil";
import {
  fcDimsAndWeightProductDimsState,
  fcDimsAndWeightProductState,
} from "crossdock/modes/inspection/fc-dims-and-weight/FcDimsAndWeightState";
import { useScanFlow } from "crossdock/common/flow/useScanFlow";
import { useMount, useUnmount } from "react-use";
import { ScanFlowButtonType } from "crossdock/common/flow/ScanFlowButtonType";

export const useFcDimsAndWeightCaptureCubiscanImages = () => {
  const product = useRecoilValue(fcDimsAndWeightProductState);
  const dims = useRecoilValue(fcDimsAndWeightProductDimsState);

  const { showFlowButton, hideAllFlowButtons } = useScanFlow();

  useUnmount(() => {
    hideAllFlowButtons();
  });

  useMount(() => {
    hideAllFlowButtons();
    showFlowButton(ScanFlowButtonType.FC_DIMS_AND_WEIGHT_BACK_TO_PRODUCT_DIMS_BUTTON);
    showFlowButton(ScanFlowButtonType.FC_DIMS_AND_WEIGHT_COMPLETE_BUTTON);
  });

  return {
    productInfo: product,
    dims,
  };
};
